/* eslint-disable @typescript-eslint/ban-ts-comment */
import summaryCommonStore from "@/store/summaryCommon.store";
import { useMemo, useRef } from "react";
import { formatRecordTime } from "@/utils/formatter";
import "./style.css";
import Textarea from "@/component/Textarea";
import summaryChapterStore from "@/store/summaryChapter.store";
import Keyframe from "@/sections/Summary/Keyframe";
import MobileImagePreviewer, { MobileImagePreviewerRef } from "@/component/MobileImagePreviewer";
import ImagePreviewer from "@/component/ImagePreviewer";
import { maxMobileWidth } from "@/constants/share";
import SummarySkeleton from "../SummarySkeleton";
import avPlayerStore from "@/store/avPlayer.store";

const Chapter = () => {
  const audioInfo = summaryCommonStore((state) => state.audioInfo);
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);
  const chapterInfo = summaryChapterStore((state) => state.chapterInfo);
  const modifyChapterInfo = summaryChapterStore((state) => state.modifyChapterInfo);
  const newChapterInfo = summaryChapterStore((state) => state.newChapterInfo);
  const retryStatus = summaryCommonStore((state) => state.retryStatus);
  const chapterLoading = summaryChapterStore((state) => state.chapterLoading);
  const keyframeArr = summaryChapterStore((state) => state.keyframeArr);
  const chapterList = chapterInfo?.srcChapterList;
  const newChapterList = newChapterInfo?.srcChapterList;
  const renderingChapterList = useMemo(() => (summaryEditing ? newChapterList : chapterList), [summaryEditing, newChapterInfo, chapterList]);
  const isRetrying = retryStatus === 1;
  const imagePreviewerRef = useRef<MobileImagePreviewerRef>(null);

  const handleClickTimeLine = (time: number) => {
    const audioPlayerIns = avPlayerStore.getState().audioPlayerIns;
    audioPlayerIns?.setCurrentTime(time);
  };

  const handleContentChange = (content: string, index: number) => {
    if (!renderingChapterList) return;
    const newChapterList = renderingChapterList.map((chapter, i) => {
      if (i === index) {
        return { ...chapter, summary: content };
      }
      return chapter;
    });
    modifyChapterInfo({ complateChapterList: newChapterList });
  };

  const handleTopicChange = (topic: string, index: number) => {
    if (!renderingChapterList) return;
    const newChapterList = renderingChapterList.map((chapter, i) => {
      if (i === index) {
        return { ...chapter, topic };
      }
      return chapter;
    });
    modifyChapterInfo({ complateChapterList: newChapterList });
  };

  const handlePreview = (keyframeIndex?: number) => {
    const images = chapterKeyframesArr.flat();
    const imageUrls = images.map(item=>item.keyFrameUrl);
    imagePreviewerRef.current?.handlePreview(imageUrls, keyframeIndex)
  }

  const chapterKeyframesArr = useMemo(
    () =>{
      if(renderingChapterList && keyframeArr){
        let keyframeIndex = 0;
        const formatKeyframeArr = keyframeArr.map(item=>{
          const chapterIndex = renderingChapterList.findIndex(chapter=> (item.beginTimestamp >= chapter.starttime && item.beginTimestamp <= chapter.endtime) || (item.endTimestamp >= chapter.starttime && item.endTimestamp <= chapter.endtime));
          item.chapterIndex = chapterIndex;
          return item;
        });
        return renderingChapterList.map((_chapter, chapterIndex) => {
          return formatKeyframeArr.filter(item=> {
            if(item.chapterIndex === chapterIndex){
              item.keyframeIndex = keyframeIndex;
              keyframeIndex++;
              return true;
            }
            return false;
          });
        });
      }
      return [];
    },
    [renderingChapterList, keyframeArr]
  );

  return (
    <div>
      {isRetrying || chapterLoading ? (
        <SummarySkeleton />
      ) : (
        <>
        {renderingChapterList?.map((chapter, index) => {
          const chapterKeyframes = chapterKeyframesArr[index] || [];
          const displayKeyframes = chapterKeyframes.slice(0, 3);
          const hiddenKeyframesLen = chapterKeyframes.length - displayKeyframes.length;
          return (
            <div key={chapter.starttime} className={`mt-2.5 flex flex-row`}>
              {/* 左边的装饰 */}
              <div className="w-2 flex-grow-0 flex flex-col items-center mt-1.75 mr-4">
                <div className="rounded size-2 bg-#DBDEE4"></div>
                <div className="dashline mt-5.75 flex-1  "></div>
              </div>
              {/* 右边的内容 */}
              <div className="flex-1 select-text pb-4">
                <div
                    className={`h-5.5 w-16 text-center color-mx-tertiary lh-5.5 font-400 text-3 border-1 border-solid border-#DBDEE4 rounded-25 ${audioInfo?.audioSrc && 'cursor-pointer  active:bg-#4981F2 active:color-#fff'}`}
                    onClick={() => {
                      handleClickTimeLine(chapter.starttime / 1000);
                    }}
                  >
                    {formatRecordTime(chapter.starttime / 1000)}
                  </div>
                {summaryEditing ? (
                  <Textarea
                    className="color-#191D26 lh-5.5 font-500 text-3.75 mt-4 mb-2 border-0 outline-0 w-full"
                    value={chapter.topic}
                    autoSize
                    onChange={(e) => {
                      handleTopicChange(e.target.value, index);
                    }}
                  />
                ) : (
                  <div className="color-#191D26 lh-5.5 font-500 text-3.75 mt-4 mb-2">{chapter.topic}</div>
                )}
                {summaryEditing ? (
                  <Textarea
                    className="mt-2 color-#626773 lh-7 font-400 text-3.5 border-0 outline-0 w-full"
                    value={chapter.summary}
                    autoSize
                    onChange={(e) => {
                      handleContentChange(e.target.value, index);
                    }}
                  />
                ) : (
                  <div className="mt-2 color-#626773 lh-7 font-400 text-3.5">{chapter.summary}</div>
                )}
                <Keyframe index={index} displayKeyframes={displayKeyframes} hiddenKeyframesLen={hiddenKeyframesLen} handlePreview={handlePreview} />
              </div>
            </div>
          );
        })}
        {document.documentElement.clientWidth <= maxMobileWidth ? <MobileImagePreviewer ref={imagePreviewerRef} />: <ImagePreviewer ref={imagePreviewerRef} />}
        </>
      )}
    </div>
  );
};

export default Chapter;
